import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "register-form" }
const _hoisted_2 = { class: "mt-10" }
const _hoisted_3 = {
  key: 0,
  class: "mt-8"
}
const _hoisted_4 = { class: "text-xs ml-1 mt-0.5" }
const _hoisted_5 = {
  key: 0,
  class: "mt-8"
}
const _hoisted_6 = { class: "mt-6 block" }
const _hoisted_7 = {
  key: 1,
  class: "mt-8 text-center"
}
const _hoisted_8 = { class: "w-16 h-16 text-green-500 mb-6 mx-auto" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-2xl font-bold leading-9 tracking-tight text-gray-900" }, "Registration completed", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-6 text-gray-500" }, "Please activate your account by email.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenproxLink = _resolveComponent("GenproxLink")!
  const _component_AuthModuleTitle = _resolveComponent("AuthModuleTitle")!
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_GenproxDivider = _resolveComponent("GenproxDivider")!
  const _component_GenproxButton = _resolveComponent("GenproxButton")!
  const _component_CheckCircle = _resolveComponent("CheckCircle")!
  const _component_DemoModal = _resolveComponent("DemoModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isRegistrationCompleted)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(_component_AuthModuleTitle, { title: "Create a new account" }, {
            default: _withCtx(() => [
              _createTextVNode(" Already have an account? "),
              _createVNode(_component_GenproxLink, {
                class: "text-black",
                to: "/auth/login"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Sign in")
                ], undefined, true),
                _: 1
              })
            ], undefined, true),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _createVNode(_component_FormKit, {
                type: "form",
                id: "login",
                "incomplete-message": false,
                "form-class": "space-y-6",
                actions: false,
                onSubmit: _ctx.register
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_FormKit, {
                    label: "Email address",
                    modelValue: _ctx.email,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                    type: "email",
                    name: "email",
                    id: "email",
                    disabled: _ctx.$route?.params?.userData ? true : false,
                    validation: "required|email"
                  }, null, 8, ["modelValue", "disabled"]),
                  _createVNode(_component_FormKit, {
                    label: "First name",
                    modelValue: _ctx.name,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
                    type: "text",
                    name: "firstName",
                    id: "firstName",
                    validation: "required"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_FormKit, {
                    label: "Surname",
                    modelValue: _ctx.surname,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.surname) = $event)),
                    type: "text",
                    name: "surname",
                    id: "surname",
                    validation: "required"
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_FormKit, {
                    label: "Password",
                    modelValue: _ctx.password,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.password) = $event)),
                    type: "password",
                    name: "password",
                    id: "password",
                    validation: [['required'], ['matches', /^(?=.*[A-Z])(?=.*[!@#$&*^%])(?=.*[0-9])(?=.*[a-z]).{8,}$/]],
                    validationMessages: {
                matches: 'Password is too weak. It must be at least 8 characters long and include one uppercase, one lowercase letter and number or special character.'
              }
                  }, null, 8, ["modelValue", "validation", "validationMessages"]),
                  _createVNode(_component_FormKit, {
                    label: "Repeat password",
                    modelValue: _ctx.repeatPassword,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.repeatPassword) = $event)),
                    type: "password",
                    name: "password_confirm",
                    id: "password",
                    validation: "required|confirm"
                  }, null, 8, ["modelValue"]),
                  (!_ctx.isRegisterFromMail)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        (!_ctx.isRegisterFromMail)
                          ? (_openBlock(), _createBlock(_component_FormKit, {
                              key: 0,
                              modelValue: _ctx.investorType,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.investorType) = $event)),
                              type: "radio",
                              label: "I am",
                              "legend-class": "$remove:mb-2 mb-4",
                              "decorator-icon": "circle",
                              options: [
                  { label: 'Fund Manager', value: _ctx.UserTypes.fundManager, attrs: { disabled: true } },
                  { label: 'Startup Founder', value: _ctx.UserTypes.startupFounder, attrs: { disabled: true } },
                  { label: 'Private Investor', value: _ctx.UserTypes.privateInvestor, attrs: { disabled: true } },
                ]
                            }, null, 8, ["modelValue", "options"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_GenproxDivider),
                  _createVNode(_component_FormKit, {
                    modelValue: _ctx.agreement,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.agreement) = $event)),
                    type: "checkbox",
                    id: "privacyPolicy",
                    name: "privacyPolicy",
                    "decorator-icon": "check",
                    validation: "accepted",
                    "wrapper-class": "$remove:items-center",
                    "validation-messages": { accepted: 'Please accept privacy policy.' },
                    "message-class": "ml-7"
                  }, {
                    label: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createTextVNode(" I consent to the processing of my data in accordance with GDPR and declare that I have read the "),
                        _createVNode(_component_GenproxLink, { onClick: _ctx.showRegulations }, {
                          default: _withCtx(() => [
                            _createTextVNode("privacy policy and terms and conditions")
                          ], undefined, true),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "validation-messages"]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_GenproxButton, {
                      class: "w-full",
                      isLoading: _ctx.isLoading,
                      type: "submit"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Register")
                      ], undefined, true),
                      _: 1
                    }, 8, ["isLoading"])
                  ])
                ], undefined, true),
                _: 1
              }, 8, ["onSubmit"])
            ]),
            (!_ctx.isRegisterFromMail)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_GenproxDivider, null, {
                    default: _withCtx(() => [
                      _createTextVNode("or")
                    ], undefined, true),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_GenproxButton, {
                      class: "w-full",
                      variant: "white",
                      outline: true,
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showDemoModal = true))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Request a demo")
                      ], undefined, true),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_CheckCircle, { class: "w-full h-full object-contain" })
          ]),
          _hoisted_9,
          _hoisted_10
        ])),
    (!_ctx.isRegisterFromMail && _ctx.showDemoModal)
      ? (_openBlock(), _createBlock(_component_DemoModal, {
          key: 2,
          onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showDemoModal = false))
        }))
      : _createCommentVNode("", true)
  ]))
}